const ROUTES = {
  ARTIGOS: '/artigos',
  SUGESTAO: '/sugestao',
  AVALIACAO: '/avaliacao',
  SOLICITACAO: '/solicitacao',
};

export default ROUTES;
